export default __webpack_public_path__ + "static/media/19.3a095e90.png";